import React, { useState, useMemo } from 'react';
import convert from 'convert-units';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBalanceScale, faAppleAlt } from '@fortawesome/free-solid-svg-icons'

import { Link } from "react-router-dom";
import Weight from '../ui/Weight.js';
import api from '../../api/index.js';

import { callback } from '../../helpers.js';

import './ProcessorSummary.scss';

export default (props) => {
	return <div className="processor-summary">
		<h3>{props.ProcessorName}</h3>
		
		<Link to={"/harvestrecords?q=" + encodeURIComponent(props.ProcessorName)} title={"Harvest Records for " + props.ProcessorName}><FontAwesomeIcon icon={faAppleAlt}/> Harvest Records</Link>
		<Weight value={props.RecordedWeight} precision={0} nan="—" />
		<br />
		<Link to={"/processors/" + props.ProcessorID + '/receipts'} title={"Processor Receipts for " + props.ProcessorName}><FontAwesomeIcon icon={faBalanceScale}/> Processor Receipts</Link>
		<Weight value={props.ReceiptWeight} precision={0} nan="—" />
	</div>;
}